<!-- media-preview.component.html -->
<div class="media-preview-container">

  @switch (mediaType) {

    <!-- Text Content -->
    @case (ContentMessageType.Text) {
      <div class="text-preview">
        <!-- Display translated content if enabled and available, otherwise original -->
        @if (safeTranslatedText) {
          <span [innerHTML]="safeTranslatedText"></span>
        } @else {
          <span [innerHTML]="safeOriginalText"></span>
        }
      </div>
    }

    <!-- Image Content -->
    @case (ContentMessageType.Image) {
      <div class="image-preview">
        @if (!showImagePlaceholder) {
          <!-- Use safeUrl for image source -->
          <img [src]="safeUrl" [alt]="'agent.doc.imagePreview' | translate" (error)="onImageError($event)" />
        } @else {
          <!-- Placeholder for broken image -->
          <div class="image-placeholder">
            <i class="placeholder-icon pi pi-image"></i> <!-- Changed to PrimeNG icon -->
            <span>{{ 'agent.doc.previewUnavailable' | translate }}</span>
          </div>
        }
      </div>
    }

    <!-- Video Content -->
    @case (ContentMessageType.Video) {
      <div class="video-preview">
        <!-- Use safeUrl for video source -->
        <video controls preload="metadata">
          <source [src]="safeUrl" /> <!-- Let browser determine type -->
          {{ 'agent.doc.videoNotSupported' | translate }}
        </video>
      </div>
    }

    <!-- Audio Content -->
    @case (ContentMessageType.Audio) {
      <div class="audio-preview">
        <!-- Use direct audio element with safeUrl -->
        <audio controls preload="metadata" [src]="safeUrl">
          {{ 'agent.doc.audioNotSupported' | translate }}
        </audio>
      </div>
    }

    <!-- Document Content -->
    @case (ContentMessageType.Document) {
      <div class="document-preview enhanced" (click)="handleDocumentClick($event)" [title]="'agent.doc.clickToOpen' | translate: { name: fileName }">
        <div class="document-container">
          <div class="document-icon-wrapper">
            <!-- Dynamic icon based on file extension -->
            <i class="document-file-icon pi" [ngClass]="getIconClass()"></i> <!-- Changed to PrimeNG icon -->
          </div>
          <div class="document-info">
            <div class="document-title">{{ getDisplayName() }}</div>
            <div class="document-meta">
              <span class="document-type">{{ getDisplayType() }}</span>
              <span class="document-meta-text">&nbsp;•&nbsp;{{ 'agent.doc.download' | translate }}</span>
            </div>
          </div>
          <div class="document-action">
            <i class="action-icon pi pi-download"></i> <!-- Changed to PrimeNG icon -->
          </div>
        </div>
      </div>
    }

    <!-- Fallback/Unsupported Content -->
    @default {
      <div class="unsupported-preview document-preview enhanced" (click)="handleDocumentClick($event)" [title]="'agent.doc.clickToAttemptOpen' | translate: { name: fileName || 'file' }">
        <div class="document-container">
           <div class="document-icon-wrapper">
            <!-- Generic file icon -->
            <i class="document-file-icon pi pi-file"></i> <!-- Changed to PrimeNG icon -->
          </div>
          <div class="document-info">
            <!-- Display filename or a default -->
            <div class="document-title">{{ fileName || ('agent.doc.unsupportedFile' | translate) }}</div>
            <div class="document-meta">
              <!-- Indicate lack of preview -->
              <span class="document-type">{{ fileExtension || 'UNKNOWN' }}</span>
              <span class="document-meta-text">&nbsp;•&nbsp;{{ 'agent.doc.previewNotAvailable' | translate }}</span>
            </div>
          </div>
          <div class="document-action">
            <!-- Static download/open icon -->
            <i class="action-icon pi pi-external-link"></i> <!-- Changed to PrimeNG icon -->
          </div>
        </div>
      </div>
    }
  }
</div>
